// ES Modules syntax
import Unsplash from 'unsplash-js';
export const unsplash = new Unsplash({ accessKey: "R-lyxSZ7bCdJwJ3HD8TmNsHz5lh0ScsZyf-igIN0fzk" });
